<template>
    <div v-if="myObdobia">
        <div v-if="myObdobia.length == 0">
            <h3>Aktuálne nemáš semestre na hodnotenie</h3>
        </div>
        <div v-if="myObdobia.length > 0">
            <v-row v-for="obdobie,index in myObdobia" :key="index" style="margin:1px;border: 1px solid black;" @click="rozbalObdobie(index)">
                <v-col cols="12">
                    <v-row :style="getObdobieStyle(obdobie.hlasovane,obdobie.pocet)" style="border: 1px solid black;">
                        <v-spacer />
                        <b>{{obdobie.obdobie}}</b>
                        &nbsp; &nbsp; &nbsp;  
                        {{obdobie.hlasovane}} / {{obdobie.pocet}}                           
                        <v-spacer />
                        <v-icon  v-if="rozbalitObdobie != index" @mousedown="rozbalObdobie(index)">chevron_left</v-icon>
                        <v-icon  v-if="rozbalitObdobie == index" @mousedown="rozbalitObdobie = -1">expand_more</v-icon>
                    </v-row>    
                </v-col>
                <v-col cols="12" v-if="rozbalitObdobie == index">                        
                    <v-row v-for="predmet, index2 in mySubjects" :key="index2" :class="index2 % 2 === 0 ? 'even-row' : 'odd-row'">
                            <b>
                            {{ predmet.skratka }} - {{ predmet.nazov }} ({{predmet.prednasky}}/{{ predmet.seminare }}) - {{ predmet.hodnotenie }}
                            </b>
                            <v-spacer />
                            <v-btn color="red" size="x-small" @click="hodnotPredmet(predmet.predmet_id, 'P', obdobie.obdobie)" v-if="predmet.prednasky && predmet.odhlasovaneP == 0">Predn.</v-btn>
                            <v-btn color="green" size="x-small" v-if="predmet.odhlasovaneP == 1" disabled>Prednášajúci</v-btn>
                            &nbsp;
                            <v-btn color="red" size="x-small" @click="hodnotPredmet(predmet.predmet_id, 'C', obdobie.obdobie)" v-if="predmet.seminare && predmet.odhlasovaneC == 0">Cvic.</v-btn>
                            <v-btn color="green" size="x-small" v-if="predmet.odhlasovaneC == 1" disabled>Cvičiaci</v-btn>
                            &nbsp;
                            <v-btn color="red" size="x-small" @click="hodnotPredmet(predmet.predmet_id, 'S', obdobie.obdobie)" v-if="predmet.odhlasovaneS == 0">Predm.</v-btn>
                            <v-btn color="green" size="x-small" v-if="predmet.odhlasovaneS == 1" disabled>Obsah a skúška</v-btn>                       
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            myObdobia: null, 
            myData : null,
            rozbalitObdobie: -1,
            mySubjects: null,
            rozbalitSubject: -1,
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.getSeassons()            
        },
        getSeassons() {
            axios.get('/get-student-seassons', this.$store.getters.getAxiosConfig)
            .then(res => {
                // console.log(res.data)
                if (res.data.message == 'OK') {
                    this.myObdobia = res.data.seassons
                    this.rozbalObdobie(0)
                }else {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
       },
       rozbalObdobie(_index) {
            this.rozbalitObdobie = _index
            this.getSubjects(this.myObdobia[_index])
        },
        getSubjects(_obdobie) {
            this.subject_finished = false
            const _data = {
                obdobie: _obdobie.obdobie
            }
            axios.post('/get-my-subjects', _data, this.$store.getters.getAxiosConfig)
                .then(res => {
                    if (res.data.message == 'OK') {
                        this.mySubjects = res.data.predmety
                    }else {
                        this.$store.commit('setFeedback', res.data.message)
                    } 
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error.name+': '+error.message)
                })

       },
       hodnotPredmet(_predmet_id, _typ, _obdobie) {
           this.$router.push({name:'eval_quest', params: {predmet_id: _predmet_id, typ_dot:_typ, obdobie: _obdobie}}) 
       },
       getObdobieStyle(_hlasovane, _pocet) {
          if (_hlasovane == _pocet) {
            return "background-color:#E8F5E9"
          } else {
            return "background-color:#f4b7bf"
          }
       }
    }
}
</script>

<style>
    .even-row {
        background-color: #E8F5E9; /* Farba pre párne riadky */
        margin:0px;
    }

    .odd-row {
        background-color: #ffffff; /* Farba pre nepárne riadky */
        margin:0px;
    }

</style>